import { connect, useDispatch } from "react-redux";
import Carousel from "../../../../components/Carousel";
import Image from '../../../../components/Image';
import Icon from '../../../../components/Icon';
import { medals } from "../../../../constants/medals";
import arrowForwardUpRight from '../../../../assets/icons/arrow_forward_up_right-semibold.svg'
import chevronDownBlack from "../../../../assets/icons/chevron-down-black.svg"
import { useWindowSize } from "../../../../hooks/useWindowSize";
import { useCallback, useMemo } from "react";
import {
  Container,
  Medal,
  Content,
  ExploreButton,
  Title,
  ToogleButton,
  Flex,
  UnlockedCategoryCarouselContainer,
  UnlockedCategoryBadgeContainer,
  Subtitle,
  New
} from './styles'
import { CategoryDto } from "../../../../types/category";
import { Separator } from "../../../../components/StyledComponents";
import UnlockedCategoryMedal from "../../../components/UnlockedCategoryMedal";
import { LockedCategoryPlacehoder } from "./componets/LockedCategoryPlaceholder";
import { showPreference } from "../../../../helpers/preferenceVisible";
import { savePreference } from "../../../../store/actions/preferences";

const UnlockedCategoryBadged = ({ allCategories, group, preferences, preferencesStates }) => {
  const dispatch = useDispatch()
  const { isMobile } = useWindowSize()

  const getLink = useCallback((category) => {
    return `/group/${group?.id}/p/c/${category?.id}`
  }, [group])

  const unlockedCategories = useMemo(() => {
    return allCategories
      ?.filter(item => item?.is_unlockable && item?.locked_ordinal)
      ?.filter(item => item?.last_posts && item?.last_posts?.length > 0)
      ?.filter(item => item?.user_access_data?.is_unlocked)
      ?.sort((a, b) => b.locked_ordinal - a.locked_ordinal);
  }, [allCategories]);

  const isMinimized = useMemo(() => {
    const preference = showPreference({
      preferences,
      preferencesStates,
      id: "unlocked-categories-carousel-view",
    })

    console.log("isMinimized", preference)
    return preference
  }, [preferences])


  const changeLayout = useCallback(() => {
    dispatch(
      savePreference({
        preferenceSlug: "unlocked-categories-carousel-view",
        preferenceValue: !isMinimized,
      })
    );
  }, [isMinimized])

  const hasLockedCategories = useMemo(() => {
    return allCategories?.some(item =>
      item?.is_unlockable &&
      item?.locked_ordinal &&
      item?.user_access_data?.is_unlocked === false
    );
  }, [allCategories]);

  const lockedCardPlaceholder = {
    isLockedPlaceholder: true
  };

  if (!unlockedCategories || unlockedCategories?.length <= 0 || !group || !allCategories) {
    return <></>
  }



  return (isMinimized ?
    <UnlockedCategoryBadgeContainer>
      <Flex style={{ gap: 18 }}>
        <UnlockedCategoryMedal category={unlockedCategories[0]} width={isMobile ? "25px" : "35px"} height="auto" />
        <Title>Ya has desbloqueado <span>{unlockedCategories?.length} categorías</span></Title>
      </Flex>
      <ToogleButton onClick={changeLayout} className="minimized">
        {isMobile ?
          "Ver más" :
          <>Expandir  <Icon icon={chevronDownBlack} size={"20px"} color="#2D3436" /></>
        }
      </ToogleButton>
    </UnlockedCategoryBadgeContainer>
    :
    <UnlockedCategoryCarouselContainer>
      <Flex style={{ padding: isMobile ? "0px 12px" : "0px 45px", alignItems: isMobile ? "flex-start" : "center" }}>
        <Flex style={{ flexDirection: "column", alignItems: "flex-start", justifyContent: "flex-start", gap: isMobile ? 21 : 12 }}>
          <Title>{!isMobile && "🏅"} Mis categorías desbloqueadas</Title>
          <Subtitle>¡Felicitaciones! Ya desbloqueaste todos estos contenidos avanzados.</Subtitle>
        </Flex>

        <ToogleButton onClick={changeLayout}>
          {!isMobile && "Minimizar"}
          <Icon icon={chevronDownBlack} size={"20px"} color="#2D3436" style={{ transform: "rotate(180deg)" }} />
        </ToogleButton>
      </Flex>

      <Separator height={{ desktop: "26px", mobile: "21px" }} />

      <Carousel
        showBullets={true}
        items={hasLockedCategories
          ? [...unlockedCategories, lockedCardPlaceholder]
          : unlockedCategories}
        renderItem={(category: CategoryDto & { isLockedPlaceholder?: true }, index) => {

          if (category?.isLockedPlaceholder) {
            return (
              <LockedCategoryPlacehoder key={`locked-placeholder-${index}`} />
            );
          }

          return (
            <Container
              {...(category?.locked_ordinal ? { unlockOrder: category?.locked_ordinal } : {})}
              key={`unlocked-category-carousel-item-${index}`}
            >
              {index === 0 && <New>¡NUEVO!</New>}
              <UnlockedCategoryMedal category={category} width="auto" height="90px" />

              <div style={{ height: 8 }} />

              <Content {...(category?.locked_ordinal ? { color: category?.locked_ordinal >= 8 && category?.locked_ordinal <= 10 ? 'white' : 'black' } : {})} >
                <h4>Desbloqueaste un nuevo nivel:</h4>
                <div style={{ height: 8 }} />
                <h2>{category?.name}</h2>
              </Content>

              <div style={{ height: 16 }} />

              <ExploreButton href={getLink(category)} target="_blank">
                <span>Explorar ahora</span>
                <Icon icon={arrowForwardUpRight} size="16px" color="white" />
              </ExploreButton>
            </Container>
          );
        }}
        slidesToShow={3}
        scrollAmount={250}
        animationSpeed={400}
        showArrows={unlockedCategories?.length >= 4}
        style={{
          padding: isMobile ? "0px 12px 10px" : "0px 45px 10px",
          scrollSnapType: "x mandatory",
          scrollPadding: isMobile ? "0px 12px" : "0px 45px"
        }}
      />
    </UnlockedCategoryCarouselContainer>
  )
}

const state = ({ categoryStore, groupStore, preferencesStore }) => {
  const { data: allCategories } = categoryStore.allCategories;
  const { data: group } = groupStore.group;
  const { data: preferences, states: preferencesStates } = preferencesStore.preferences;

  return {
    group,
    allCategories,
    preferences,
    preferencesStates
  };
};


export default connect(state)(UnlockedCategoryBadged)